import { DataContractTct, PostInvestorDraftInstanceRes } from '@dealstack/shared/lib/generated';
import { Table } from '@dealstack/frontend/shared/components/Table/Table/Table';
import { useContractTable } from '@dealstack/frontend/shared/components/Investors/Substeps/ContractTable/useContractTable';

interface Props {
	investors?: PostInvestorDraftInstanceRes[];
	contracts?: DataContractTct[];
	contractsChecked?: Map<string, Set<string>>;
	onContractCheckboxClick: (contractId: string, investorId: string) => void;
	areAllInvestorsSelected: (contractId: string) => boolean;
	onContractSelectAll: (contractId: string) => void;
}

export const ContractTable = ({
	investors,
	contracts,
	contractsChecked,
	onContractCheckboxClick,
	areAllInvestorsSelected,
	onContractSelectAll,
}: Props) => {
	const { tableInstance } = useContractTable(
		areAllInvestorsSelected,
		onContractSelectAll,
		onContractCheckboxClick,
		contractsChecked,
		investors,
		contracts
	);

	return (
		<div className="mt-10">
			<Table tableInstance={tableInstance} />
		</div>
	);
};
